import React from 'react';

const TypeSelector = ({
  selectedType,
  setSelectedType,
  types,
}) => (
  <div style={{ background: '#F4F4F4', padding: '8px 16px', marginTop: 8 }}>
    <table className="type-table">
      <tbody>
        <tr>
          <td>
            <div
              className={!selectedType ? 'type-title active' : 'type-title'}
              onClick={() => { setSelectedType(null); }}
            >
              全部
            </div>
          </td>
          {
        (types || []).map((type) => (
          <td key={type}>
            <div
              className={type === selectedType ? 'type-title active' : 'type-title'}
              onClick={() => { setSelectedType(type); }}
            >
              {type}
            </div>
          </td>
        ))
      }
        </tr>
      </tbody>
    </table>
  </div>
);

export default TypeSelector;
